import React from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'

import listKanton from './kanton-data.csv'

import { KantonTitel } from '../kantontitel'
import { KantonWappen } from '../kantonwappen'
import { KantonParteien } from '../kantonparteien'
import { KantonText } from '../kantontext'

export function Dashboard(props) {
  return listKanton.map((k, index) => {
    return (
      <div className='ui text container kanton' key={k.kanton + index}>

        <KantonTitel titel={k.kanton + ': ' + k.titel} />
        <div className='dashboardWrapper'>
          <div className='leftWrapper'>
            <KantonWappen
              kantonWappen={k.kanton}
              totalSitze={k.totalSitze}
              sitzveraenderung={k.sitzveraenderung}
            />
          </div>

          <div className='rightWrapper'>
            <table className='ui table compact very basic unstackable'>
              <thead>
                <tr>
                  <th className='tableTitle'>Partei</th>
                  <th className='tableTitle'>2015, Nationalrat</th>
                  <th className='tableTitle'>Trend</th>
                </tr>
              </thead>
              <tbody>
                <KantonParteien kanton={k.kanton} />
              </tbody>
            </table>
          </div>
        </div>
        <KantonText text={k.text} />
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: (index + 1) * 3.1 + 20 + 'ContentRead'
              })
            }
          }}
        />
      </div>
      
    )
  })
}
